import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AudienceWelcome from "./AudienceWelcome";
import { audienceSites, legacyHomeAnchors } from "../audience/audienceSites";
import "./AudienceHome.css";

export default function Home() {
  const { hash, search } = useLocation();
  const requested = new URLSearchParams(search).get("audience");
  const legacyTarget = legacyHomeAnchors[hash] ||
    (Object.prototype.hasOwnProperty.call(audienceSites, requested) ? audienceSites[requested].base : null);
  if (legacyTarget) return <Navigate to={legacyTarget} replace />;
  return <main id="main-content" className="audience-home"><AudienceWelcome /></main>;
}
